import React from 'react';

type ResponsiveTableWrapperProps = {
  children: React.ReactNode;
  className?: string;
};

const ResponsiveTableWrapper: React.FC<ResponsiveTableWrapperProps> = ({ children, className }) => (
  <div className={`overflow-x-auto ${className || ''}`}>
    <div className="inline-block min-w-full align-middle">{children}</div>
  </div>
);

export default ResponsiveTableWrapper;
